import React from 'react'

import Modal from '../index'

import Button from '../../../styled-base/button'

const noop = () => {}

export default function ConfirmModal ({
  title,
  children,
  onAccept = noop,
  onDecline = noop,
  isSaving = false,
  acceptText = 'Accept',
  declineText = 'Cancel',
}) {
  return (
    <Modal>
      <Modal.Header onClose={onDecline}>
        { title }
      </Modal.Header>
      <Modal.Content>
        { children }
      </Modal.Content>
      <Modal.Footer>
        <Button isFlat type="primary" onClick={onDecline}>
          { declineText }
        </Button>
        <Button type="primary" onClick={onAccept} isSaving={isSaving}>
          { acceptText } 
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
